import { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email });
      toast.success('Password reset link sent to your email');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0E0A1F] text-white px-4">
      <div className="bg-[#1C1235] p-8 rounded-xl shadow-md w-full max-w-md text-white">
      <div className="flex justify-center mb-6">
          <img src="/Spark_01.png" alt="Sparks Logo" className="h-12" />
        </div>
        <h2 className="text-2xl font-bold text-center mb-2">Forgot Password</h2>
        <p className="text-sm text-center mb-6 font-light">Enter your email to reset your password</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm block mb-1 font-light text-white">Email</label>
            <input
              type="email"
              className="w-full p-3 border border-[#6D5BAF] rounded bg-white text-[#34304D]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded text-white font-semibold bg-[#6D5BAF] hover:bg-[#5a4aa5] transition"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <p className="text-sm text-center mt-4 text-white font-light">
          Already have an account?{' '}
          <span
            onClick={() => navigate('/login')}
            className="cursor-pointer font-medium text-[#6D5BAF] hover:underline"
          >
            Log in
          </span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
